import React, { useEffect, useState } from "react";
import ModalComponent from "../../../components/modals/ModalComponent";
import SkeletonTable from "../../../components/table/SkeletonTable";
import Delete from "../../../assets/Delete";
import View from "../../../assets/View";
import GlobalTooltip from "../../../components/common/GlobalTooltip";
import { DeleteFileFolderApi } from "../../../api/request/documents/documents";
import toast from "react-hot-toast";
import { Spin } from "antd";

const VerifyDocModal = ({
  isOpen,
  setIsOpen,
  data,
  userId,
  getFileDetails,
}) => {
  const [documents, setDocuments] = useState([]);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const defaultRender = (value) => (value ? value : "--");

  const columns = [
    {
      title: "File Name",
      dataIndex: "original_name",
      render: defaultRender,
    },
    {
      title: "Reason",
      dataIndex: "reason",
      render: defaultRender,
    },
    {
      title: "Status",
      dataIndex: "status",
      render: defaultRender,
    },
    {
      title: "Action",
      dataIndex: "view_file",
      render: defaultRender,
    },
  ];

  const deleteItemHandler = async (id) => {
    try {
      setIsDeleteLoading(true);
      const params = { id: id, user_id: userId };
      const { data } = await DeleteFileFolderApi(params);
      if (data?.status) {
        toast.success(data?.message);
        setIsOpen(false);
        getFileDetails();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setIsDeleteLoading(false);
    }
  };

  useEffect(() => {
    setDocuments(
      data?.review_verify_doc?.map((item) => {
        return {
          original_name: (
            <div className="sub-title highlight-text">
              {item?.original_name || "--"}
            </div>
          ),
          reason: (
            <p
              className="truncate w-[150px]"
              title={item?.reason_of_review_doc}
            >
              {item?.reason_of_review_doc}
            </p>
          ),
          status:
            item?.is_review_verify === 2 ? (
              <p className="text-green-500">Verified</p>
            ) : (
              <p className="text-orange-400">Pending</p>
            ),
          view_file: (
            <div className="flex items-center gap-3">
              <GlobalTooltip title={"View File"}>
                <a
                  href={item?.path}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500"
                >
                  <View />
                </a>
              </GlobalTooltip>
              {
                item?.is_review_verify === 2 ? null : (
                  <GlobalTooltip title={"Delete"}>
                    <button
                      onClick={() => deleteItemHandler(item?.id)}
                    >
                      <Delete color="#EF5755"/>
                    </button>
                  </GlobalTooltip>
                )
              }
            </div>
          ),
        };
      }) || []
    );
  }, [data]);

  return (
    <ModalComponent isOpen={isOpen} setIsOpen={setIsOpen} width={800}>
      <div className="mb-5 text-center font-semibold text-xl">
        <p>Verify Documents</p>
        <p className="capitalize">{`${data?.service_name_slug} (#${data?.file_number})`}</p>
      </div>
      {isDeleteLoading ? (
        <div className="flex items-center justify-center">
          <Spin />
        </div>
      ) : (
        <SkeletonTable columns={columns} data={documents} />
      )}
    </ModalComponent>
  );
};

export default VerifyDocModal;
